import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhoneAlt,
  faEnvelope,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import "../Styles/Contact.css";
import Logo from "../Assets/logo-icon.png";

function Contact() {
  return (
    <section className="contact-section" id="contact">
      <div className="contact-wrapper">

        <div className="contact-left-panel">
          <div className="contact-logo-box">
            <img
              src={Logo}
              alt="Workforce Nexus Logo"
              className="contact-logo"
            />
          </div>

          <h2 className="contact-title">
            <span>Contact Us</span>
          </h2>

          <p className="contact-description">
            If your business is looking for reliable recruitment support,
            Workforce Nexus is here to help. We work closely with organizations
            to understand hiring needs in depth and deliver thoughtful,
            responsive, and structured support that simplifies recruitment
            and strengthens workforce success.
          </p>

          <div className="contact-feature-list">
            <div className="feature-item">
              <span>✔</span> Professional hiring support
            </div>
            <div className="feature-item">
              <span>✔</span> Structured recruitment solutions
            </div>
            <div className="feature-item">
              <span>✔</span> Long-term business partnership
            </div>
          </div>
        </div>

        <div className="contact-right-panel">

          <div className="contact-card phone-card">
            <FontAwesomeIcon icon={faPhoneAlt} />
            <h3>Phone</h3>
            <p>+91 7977602121</p>
            <a href="tel:+917977602121">
              Connect Now <FontAwesomeIcon icon={faArrowRight} />
            </a>
          </div>

          <div className="contact-card email-card">
            <FontAwesomeIcon icon={faEnvelope} />
            <h3>Email</h3>
            <p>mail.workforcenexus@gmail.com</p>
            <a href="mailto:mail.workforcenexus@gmail.com">
              Send Email <FontAwesomeIcon icon={faArrowRight} />
            </a>
          </div>

          <div className="contact-card whatsapp-card">
            <FontAwesomeIcon icon={faWhatsapp} />
            <h3>WhatsApp</h3>
            <p>+91 7977602121</p>
            <a
              href="https://wa.me/917977602121"
              target="_blank"
              rel="noreferrer"
            >
              Chat Now <FontAwesomeIcon icon={faArrowRight} />
            </a>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Contact;